module.exports = __webpack_public_path__ + "static/img/videoFm.0c2c1a73.png";